import React from 'react';
import { Link } from 'gatsby';

import { FooterContainer } from '../styles/common.css';

export default () => {
  return (
    <FooterContainer>
      <Link to="/tou">Terms of Use</Link>
      <Link to="/privacy">Privacy Statement</Link>
      <span>Fishbowl Worldwide Media, LLC. | 2024</span>
      <span className="credit">
        Maintained by{' '}
        <a
            href="https://www.islandtechnologies.net/"
            target="_blank"
            rel="noopener"
          >
            Island Technologies
          </a>
      </span>
    </FooterContainer>
  );
};
